import { type ShouldRevalidateFunctionArgs } from 'react-router'

export const DOCUMENT_REVIEW_SESSION_RESOURCE_PATH = '/ai/resources/document-review-session'

const MUTATION_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE'])

export function isDocumentReviewSessionResourceAction(formAction?: string | null) {
	if (!formAction) return false

	try {
		return new URL(formAction, 'https://iuspro.local').pathname === DOCUMENT_REVIEW_SESSION_RESOURCE_PATH
	} catch {
		return formAction.split('?')[0] === DOCUMENT_REVIEW_SESSION_RESOURCE_PATH
	}
}

export function shouldSkipDocumentReviewSessionRevalidation(opts: ShouldRevalidateFunctionArgs) {
	const method = opts.formMethod?.toUpperCase()
	if (!method || !MUTATION_METHODS.has(method)) return false
	return isDocumentReviewSessionResourceAction(opts.formAction)
}
